import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-p-2 child-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslationListView = _resolveComponent("TranslationListView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.masterDataTranslationFilter)
      ? (_openBlock(), _createBlock(_component_TranslationListView, {
          key: _ctx.masterDataTranslationFilter,
          fixedFilter: _ctx.masterDataTranslationFilter,
          allowedKeys: _ctx.allowedTranslationKeys,
          disabledNewEntryButton: "",
          onKeysLoaded: _ctx.onKeysLoaded
        }, null, 8, ["fixedFilter", "allowedKeys", "onKeysLoaded"]))
      : _createCommentVNode("", true)
  ]))
}